export default {
  Assigned: 'ASSIGNED',
  UnAssigned: 'UN_ASSIGNED',
};
